import { render, staticRenderFns } from "./EditSpecialty.vue?vue&type=template&id=130e23a8&scoped=true"
import script from "./EditSpecialty.vue?vue&type=script&lang=js"
export * from "./EditSpecialty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130e23a8",
  null
  
)

export default component.exports